import React from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import FormLayoutGroup from 'components/ui/form-layout-group';
import * as yup from 'yup';
import {
  NotesAndEndorsementsFormValues,
  getInitialValues,
  getNotesAndEndorsementsValidationSchemaShape,
  shouldShowNotesAndEndorsements,
} from './form';

interface NotesAndEndorsementsSectionProps {
  disabled?: boolean;
  initialValues?: NotesAndEndorsementsFormValues;
  onValuesChange?: (
    changedValues: any,
    allValues: NotesAndEndorsementsFormValues
  ) => void;
}

const NotesAndEndorsementsSection: React.FC<
  NotesAndEndorsementsSectionProps
> = ({
  disabled = false,
  initialValues = getInitialValues(),
  onValuesChange,
}) => {
  const { t } = useTranslation();

  if (!shouldShowNotesAndEndorsements()) {
    return null;
  }

  return (
    <FormLayoutGroup mdColumns={1}>
      <Form.Item
        label={t('contractDetail.notesAndEndorsements')}
        name="notesAndEndorsements"
        initialValue={initialValues.notesAndEndorsements}
        rules={[
          {
            validator: async (_, value) => {
              try {
                const validationSchema = yup
                  .object()
                  .shape(getNotesAndEndorsementsValidationSchemaShape(t));
                await validationSchema.validateAt('notesAndEndorsements', {
                  notesAndEndorsements: value,
                });
              } catch (error) {
                if (error instanceof Error) {
                  throw new Error(error.message);
                }
                throw new Error('Validation failed');
              }
            },
          },
        ]}
      >
        <Input.TextArea
          rows={4}
          size="large"
          placeholder={disabled ? '' : t('contractDetail.addYourNoteHere')}
          disabled={disabled}
          onChange={(e) => {
            if (onValuesChange) {
              onValuesChange(
                { notesAndEndorsements: e.target.value },
                { notesAndEndorsements: e.target.value }
              );
            }
          }}
        />
      </Form.Item>
    </FormLayoutGroup>
  );
};

export default NotesAndEndorsementsSection;
